export const CONFIG_EVENTS = {
	ADD_REMOVE_CONFIG_TYPE_SECTION: 'ADD_REMOVE_CONFIG_TYPE_SECTION',
	UPDATE_MENU: 'UPDATE_MENU'
}

export const FORM_VALUE_OPTION = {
	label: {
		DataType: 'String',
		DisplayText: 'Name',
		Name: 'label'
	}
}
